/* eslint-disable no-undef */
export default class D365WebTracking {
    init() {
        (function (a, t, i) { var e = "MSCI"; var s = "Analytics"; var o = e + "queue"; a[o] = a[o] || []; var r = a[e] || function (n) { var t = {}; t[s] = {}; function e(e) { while (e.length) { var r = e.pop(); t[s][r] = function (e) { return function () { a[o].push([e, n, arguments]); }; }(r); } } var r = "track"; var i = "set"; e([r + "Event", r + "View", r + "Action", i + "Config", i + "Property", i + "User", "initialize", "teardown"]); return t; }(i.name); var n = i.name; if (!a[e]) { a[n] = r[s]; a[o].push(["new", n]); setTimeout(function () { var e = "script"; var r = t.createElement(e); r.async = 1; r.src = i.src; var n = t.getElementsByTagName(e)[0]; n.parentNode.insertBefore(r, n); }, 1); } else { a[n] = new r[s]; } if (i.user) { a[n].setUser(i.user); } if (i.props) { for (var c in i.props) { a[n].setProperty(c, i.props[c]); } } a[n].initialize(i.cfg); })(window, document, {

            src: "https://cxppusa1rdrect01sa02cdn.blob.core.windows.net/webtracking/WebTracking/WebTracking.bundle.js",
            name: "MSCI",
            cfg: {
                ingestionKey: wtKey,
                endpointUrl: "https://mobile.events.data.microsoft.com/OneCollector/1.0/",
                autoCapture: {
                    view: true,
                    click: true
                },
                orgInfo: {
                    orgId: wtOrg,
                    orgTenantId: "002b5760-0535-4349-b358-4dc5ea124054",
                    orgGeo: "USA"
                }
            }
        });
    }
}